var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('v-container',[_c('page-header',{attrs:{"text":_vm.content.title.rendered}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.content.rendered)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }